<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_OTHER_CHANGE_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row" *ngIf="!isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <p class="page-subtitle">{{ 'COMMON_LBL_ERROR_MSG_NO_ACTIVE_LEASE' | translate }}</p>
            <p></p>
        </section>
        <section class="col-sm-2"></section>
    </div>
    <div class="row" *ngIf="isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content">
                <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm(customForm)" novalidate>
                    <p class="subtitle">{{ 'REQUEST_OTHER_CHANGE_TITLE' | translate }}</p>
                    <p></p>
                    <div class="row">              
                        <textarea 
                            class="form-control" 
                            id="note" name="note" 
                            [(ngModel)]="request.changeRequestNote" 
                            rows="4"
                            [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.note.errors }"                                        
                            required maxlength="200">
                        </textarea>  
                        <div *ngIf="formSubmitted && (customForm.controls.note.errors)" class="is-invalid-format">
                            <small> {{ 'COMMON_LBL_REQUIRED' | translate }} </small>
                        </div>   
                    </div>                   
                    <div *ngIf="formSubmitted && customForm.invalid" class="row" style="margin: auto;">
                        <div class="col-sm-12 error-note">
                            <label translate="COMMON_LBL_FORM_ERR_NOTE"></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-secondary action-row">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                        </div>
                    </div>
                </form>
                <p> </p>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>